import { render, staticRenderFns } from "./style-four.vue?vue&type=template&id=7c28608c&scoped=true&"
import script from "./style-four.vue?vue&type=script&lang=js&"
export * from "./style-four.vue?vue&type=script&lang=js&"
import style0 from "./style-four.vue?vue&type=style&index=0&id=7c28608c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c28608c",
  null
  
)

export default component.exports